// "i dag" / "i går" / "for N dager siden" / "for N uker siden" / "dd. mmm yyyy"
// Used in the redesigned profile rows so the trailing column reads as a glanceable hint.

const NB_MONTH_SHORT = [
  "jan", "feb", "mar", "apr", "mai", "jun",
  "jul", "aug", "sep", "okt", "nov", "des",
];

export function formatRelativeDate(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return "";
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return "";
  const dayMs = 86_400_000;
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const diff = Math.floor((startOfDay(now) - startOfDay(dt)) / dayMs);
  if (diff <= 0) return "i dag";
  if (diff === 1) return "i går";
  if (diff < 7) return `for ${diff} dager siden`;
  if (diff < 30) {
    const w = Math.floor(diff / 7);
    return w === 1 ? "for 1 uke siden" : `for ${w} uker siden`;
  }
  return `${dt.getDate()}. ${NB_MONTH_SHORT[dt.getMonth()]} ${dt.getFullYear()}`;
}
